// extracted by mini-css-extract-plugin
export default {"hero":"Main_hero__jjI3D","heroBox":"Main_heroBox__0x8hH","heading":"Main_heading__Oo9dD","subHeading":"Main_subHeading__vgZMN"};